var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCat5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 45,
    viewBox: "0 0 46 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\xA6\x86 icon \"money\""
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30.642 29.1988C30.642 27.0948 24.6724 25.3893 17.3087 25.3893M30.642 29.1988C30.642 31.3027 24.6724 33.0083 17.3087 33.0083C9.94486 33.0083 3.97532 31.3027 3.97532 29.1988M30.642 29.1988V38.6021C30.642 40.7726 24.6724 42.5321 17.3087 42.5321C9.94486 42.5321 3.97532 40.7726 3.97532 38.6021V29.1988M30.642 29.1988C37.9249 29.1988 43.9753 27.3186 43.9753 25.3893V6.34164M17.3087 25.3893C9.94486 25.3893 3.97532 27.0948 3.97532 29.1988M17.3087 25.3893C8.89288 25.3893 2.07056 23.509 2.07056 21.5797V12.0559M17.3087 8.2464C8.89288 8.2464 2.07056 9.95198 2.07056 12.0559M2.07056 12.0559C2.07056 14.1599 8.89288 15.8654 17.3087 15.8654C17.3087 17.7948 23.5056 19.675 30.7885 19.675C38.0714 19.675 43.9753 17.7948 43.9753 15.8654M43.9753 6.34164C43.9753 4.23769 38.0714 2.53211 30.7885 2.53211C23.5056 2.53211 17.6017 4.23769 17.6017 6.34164M43.9753 6.34164C43.9753 8.44558 38.0714 10.1512 30.7885 10.1512C23.5056 10.1512 17.6017 8.44558 17.6017 6.34164M17.6017 6.34164V25.7055",
    stroke: "#012E40",
    strokeWidth: 3.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCat5);
export default __webpack_public_path__ + "static/media/cat5.e96c479e867289a66080a6d7892e2171.svg";
export { ForwardRef as ReactComponent };